import { MeasurementData } from 'features/weather/types';
import {
  convertFromImperial,
  convertNumberFromDB,
  convertNumberToSaveToDB,
  convertToImperial,
} from 'features/weather/utils/dataConverters';
import { WeatherAlert } from 'types';
import { WeatherAlertFormWithCondition } from '../types';

export const getLabelForMeasurementType = (
  type: MeasurementData | ''
): string => {
  if (type === 'wind_kph') return 'Wind Speed';
  if (type === 'gust_kph') return 'Wind Gust';
  if (type === 'cloud_percent') return 'Cloud Cover';
  if (type === 'precip_mm') return 'Precipitation';
  return '';
};

export const getCautionAndWarningFromDBAlert = (
  weatherAlert: WeatherAlert,
  useImperial: boolean | null | undefined
) => {
  const warning = convertToImperial(
    convertNumberFromDB(weatherAlert.warning, weatherAlert.condition),
    weatherAlert.condition,
    useImperial
  )?.toFixed(2);
  const caution = convertToImperial(
    convertNumberFromDB(weatherAlert.caution, weatherAlert.condition),
    weatherAlert.condition,
    useImperial
  )?.toFixed(2);
  return { warning, caution };
};

export const prepareAlertToSaveToDB = (
  alertForm: WeatherAlertFormWithCondition,
  useImperial: null | undefined | boolean
) => {
  return {
    ...alertForm,
    dish_id: Number(alertForm.dish_id),
    caution: convertFromImperial(
      convertNumberToSaveToDB(
        alertForm.caution ? Number(alertForm.caution) : null,
        alertForm.condition
      ),
      alertForm.condition,
      useImperial
    ),
    warning: convertFromImperial(
      convertNumberToSaveToDB(Number(alertForm.warning), alertForm.condition),
      alertForm.condition,
      useImperial
    ),
  };
};
